import script from "./Cropper.vue?vue&type=script&setup=true&lang=js"
export * from "./Cropper.vue?vue&type=script&setup=true&lang=js"

import "./Cropper.vue?vue&type=style&index=0&id=4f2c89b4&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2c89b4"]])

export default __exports__